/* eslint-disable camelcase */

export default class Webhook {
	constructor({
		id,
		organization_id,
		criteria,
		formatter,
		target
	} = {}) {
		this._id = id;
		this._organization_id = organization_id || null;
		this._criteria = criteria;
		this._formatter = formatter;
		this._target = target;
	}

	getId = () => this._id;

	getKey = () => this._id.toString();

	getOrganizationId = () => this._organization_id;

	getCriteria = () => this._criteria;

	getFormatter = () => this._formatter;

	getTarget = () => this._target;
}
